import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
const NoPayments = () => (
  <Fragment>
    <Heading small>No Payments found for the selected week</Heading>
    <p>Try selecting a different week</p>
  </Fragment>
)

export default NoPayments



// WEBPACK FOOTER //
// ./src/payments/views/empty.jsx